export class WebContratoEmp {
    idContratoEmp: number;
    nrAnoEmp: number;
    nrContrato: number;
    nrSeqContrato: number;
    idPessoa: number;
    idPessoaParticipante: number;
    idModalidadeEmp: number;
    idTipoEmp: number;
    idSitContrato: number;
    idRazaoQuitacaoContrato: number;
    idPlano: number;
    idEmp: number;
    nrSeqRubrica: number;
    nrPrazo: number;
    dtSolicitacao: string;
    dtCredito: string;
    dtQuitacao: string;
    pcTaxaJuros: number;
    pcTaxaAplicada: number;
    vlSolicitado: number;
    vlPmt: number;
    vlMargemConsig: number;
    vlSalarioBase: number;
    vlReservaResgate: number;
    icCreditoEfetuado: string;
    nmInfAdicional: string;
    idManeiraPag: number;
    nrBanco: string;
    nrAgBanco: string;
    nrContaBanco: string;
    dtDesistenciaContrato: string;
    nmMotivoDesistencia: string;
    pcPrestacao: number;
    idPessoaAvalista: number;
    idSequencialPermissao: number;
    idContratoEmpPos: number;
    icSimulacao: string;
    idPessoaLogado: number;
    idPessoaConcessao: number;
    idPessoaCancelado: number;
    icXml: string;
    dtGeracaoXml: string;
    valorLiquido: number;
    dtAprovacao: string;
    icAprovacao: string;
    idSituacaoSimulacao: number;
    protocolo: string;
    icSeguro: string;
    idPerfilInvestimento: number;
    valorAmortizacao: number;
    pcSeguro: number;
    idAprovacaoSeguridade: number;
    numeroCarencia: number;
    numeroCarenciaMax: number;
    token: string;
    ipSolicitacao: string;
    processo: number;
    status: number;
    nmContratoSemAssinatura: string;
    nmAssinatura: string;
    nmContratoAssinado: string;
}